module.exports = __webpack_public_path__ + "img/a2_3project.b7330db7.png";